/**
 *    @author:
 *    @since:
 *
 */

import { ViewportScroller } from '@angular/common';
import { Util } from 'src/refresh/service/Util';
import { IValidator } from '../../_common/component/IValidator';
import { ChildDeceasedComponent} from './child-deceased.component';

export class ChildDeceasedValidation extends IValidator {

       constructor(private component: ChildDeceasedComponent) { super();
            this.viewportScroller = this.component.viewportScroller; }
       private viewportScroller:ViewportScroller;
       private success: boolean;
       public validate(): boolean {
       this.success = true;
            if(Util.isEmpty(this.component.input)){
                  //this.component.error_isChildDeceased = "setup_2.emptyIsChildDeceased";
                  this.focus("isChildDeceased","radio_isChildDeceasedRadio_0").error_isChildDeceased = "setup_2.emptyIsChildDeceased";
             } 

             return this.success;
       }

       private focus(tagId:string,ctrlId:string) : ChildDeceasedComponent {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let ctrl = document.getElementById(ctrlId);
                 ///console.log(ctrl);
                 if ( ctrl ) ctrl.focus();
            }
                 
            this.success = false;
            return this.component;
       }
}

